/* =====================================================================
 * wikiSourcePickerSlot — host-provided 프로젝트 위키 피커 DI seam.
 *
 * `MessageInput`은 shared 패키지라 enterprise 앱 아래 문서에이전트의 위키
 * API/훅을 직접 import할 수 없다. 호스트가 bootstrap 시점에 이 슬롯에 피커를
 * 등록하면 통합에이전트 "+" 메뉴에 "프로젝트 위키" 항목이 생기고, 등록하지
 * 않은 호스트에서는 항목 자체가 나타나지 않는다.
 *
 * 피커는 **첨부가 아니라 바인딩**을 돌려준다. 위키 페이지를 파일로 올리면 사람이
 * 미리 고른 페이지만 모델이 보게 되는데, 위키의 값은 에이전트가 직접 검색해
 * 필요한 페이지·원문·그림까지 따라가는 것이다. 그래서 고르는 단위는 페이지가
 * 아니라 **프로젝트 하나**다 (``lib/projectWikiBinding.ts`` 참조).
 * ===================================================================== */

import type React from 'react';
import type { ProjectWikiBinding } from './projectWikiBinding';

export interface WikiSourcePickerProps {
  open: boolean;
  onClose: () => void;
  /** 지금 이 대화에 붙어 있는 위키. 피커가 선택 상태로 표시한다. */
  current: ProjectWikiBinding | null;
  /** 고른 프로젝트를 대화에 붙인다. ``null`` 이면 뗀다. */
  onBind: (binding: ProjectWikiBinding | null) => void;
}

export type WikiSourcePickerComponent =
  React.ComponentType<WikiSourcePickerProps>;

let _impl: WikiSourcePickerComponent | null = null;

/** 앱이 최초 React render 전에 한 번 등록한다. null은 항목 제거. */
export function setWikiSourcePickerComponent(
  component: WikiSourcePickerComponent | null,
): void {
  _impl = component;
}

export function getWikiSourcePickerComponent(): WikiSourcePickerComponent | null {
  return _impl;
}
